/* eslint-disable */

const defaultTranslations = {
  en: () => ({
    title: 'powered by Ogury'
  })
};

export default defaultTranslations;
